import { ref, Ref } from 'vue'
import { User } from '@/retail/contexts/customers/services/user.service'
import { userService } from '@/retail/contexts/customers/dependency-injection'

type ReactiveUSerList = Ref<User[]>

export function useClient() {
  const clients: ReactiveUSerList = ref([])

  const findUsersByEmail = async (email): Promise<User[]> => {
    const users = (await userService.findUsersByEmail(email)) ?? []
    clients.value = users
    return users
  }

  const searchUsers = async (query: string): Promise<User[]> => {
    return userService.searchUsers(query)
  }

  const getUserByEmail = async (email: string): Promise<User> => {
    return userService.getUserByEmail(email)
  }

  const updateClientEmail = async (clientId: string, email: string): Promise<User> => {
    return userService.updateUserEmail(clientId, email)
  }

  const updateCustomer = async (clientId: string, user: Partial<User>): Promise<User> => {
    return userService.updateUser(clientId, user)
  }

  const deleteCustomer = async (clientId: string): Promise<User> => {
    return userService.deleteUser(clientId)
  }

  const getUserById = async (clientId: string): Promise<User> => {
    return userService.getUserById(clientId)
  }

  return {
    clients,
    findUsersByEmail,
    updateClientEmail,
    getUserById,
    getUserByEmail,
    deleteCustomer,
    searchUsers,
    updateCustomer,
  }
}
